import React, { Component } from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  BackHandler,
  TouchableHighlight,
  KeyboardAvoidingView,
  Platform,
  Dimensions,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import Countdown from "../components/CountDown";
import DeviceListItem from "../components/DeviceListItem";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import Loading from "../components/Loading";
import * as Actions from "../actions/DeviceActions";
import * as SwitchBinaryActions from "../actions/SwitchBinaryActions";
import * as DoorLockActions from "../actions/DoorlockActions";
import * as AreaActions from "../actions/AreaActions";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import Theme from "../argon-ui/Theme";

import {
  faPlus,
  faEdit,
  faTimes,
  faCopy,
  faExchangeAlt,
  faEraser,
  faCheckSquare,
  faSyncAlt,
  faLightbulb,
  faSlidersH,
} from "../../assets/consts/faCharCodes";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import FilterItem from "../components_v2/FilterItem";
import { Collapse, Flex, HStack, IconButton } from "native-base";
import Select from "../nativeBase-ui/Select";
import Spinner from "../components_v2/Spinner";
import InputSearch from "../components_v2/InputSearch";
import MessageBox from "../components_v2/MessageBox";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import ModalBase from "../nativeBase-ui/ModalBase";
import { updateDeviceAvailable } from "../util/updateDeviceAvailable";
const SCREEN_HEIGHT = Dimensions.get("window").height;
class DeviceListScreen extends Component {
  constructor(props) {
    super(props);
    this.model = {};
    this._sortBy_Types = {
      batteryLevel: "batteryLevel",
      alphabetic: "alphabetic",
      deviceCode: "deviceCode",
      getArray: (includeBatteryLevel = false) => {
        var arr = [];
        for (var i in this._sortBy_Types) {
          if (
            this._sortBy_Types[i] &&
            {}.toString.call(this._sortBy_Types[i]) === "[object Function]"
          ) {
            continue;
          }

          if (
            !includeBatteryLevel &&
            this._sortBy_Types[i] == this._sortBy_Types.batteryLevel
          ) {
            continue;
          }

          arr.push(this._sortBy_Types[i]);
        }
        return arr;
      },
    };

    let { deviceTypeFilter } = { ...this.props.navigation.state.params };
    var deviceSortFilter = this._sortBy_Types.alphabetic;
    if (deviceTypeFilter == DeviceTypes.BATTERY) {
      deviceSortFilter = this._sortBy_Types.batteryLevel;
    }
    this.state = {
      ...this.props.navigation.state.params, // may include areaId
      areaDevices: [], // uses for filter
      accessToken: "",
      isLoading: true,
      showCheckbox: false,
      checkedItems: [],
      checkedItemsUId: [],
      deviceList: [], // main list
      deviceTypes: [DeviceTypes.ALL],
      deviceTypeFilter: deviceTypeFilter || DeviceTypes.ALL,
      deviceNameFilter: "",
      deviceSortFilter,
      timerColor: Theme.COLORS.PRIMARY,
      isShowingDeleteAlert: false,
      showAreaRemoveConfirm: false,
      showPermanentlyDeleteConfirm: false,
      detailsModalVisible: false,
      toggleFilterCollapse: false,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceList"),
  });
  getDeviceTypes = (areaDeviceIdsFilter) => {
    var result = [DeviceTypes.ALL];
    var hasError = false;
    if (
      this.props.deviceReducer.list.some(
        (d) =>
          (!areaDeviceIdsFilter ||
            //(d.deviceUId && areaDeviceIdsFilter.indexOf(d.deviceUId) >= 0) ||
            areaDeviceIdsFilter.indexOf(d.deviceId || d.deviceUId) >= 0) &&
          d.batteryLevel >= 0
      )
    )
      result.push(DeviceTypes.BATTERY);

    for (var i in this.props.deviceReducer.list) {
      var dvc = this.props.deviceReducer.list[i];
      if (
        !areaDeviceIdsFilter ||
        //(dvc.deviceUId && areaDeviceIdsFilter.indexOf(dvc.deviceUId) >= 0) ||
        areaDeviceIdsFilter.indexOf(dvc.deviceId || dvc.deviceUId) >= 0 // if is between area devices
      ) {
        // and not selected yet
        if (result.indexOf(dvc.deviceType) < 0) result.push(dvc.deviceType);
        if (dvc.isFailed || dvc.isExcluded) hasError = true;
      }
    }

    if (hasError) result.push(DeviceTypes.MALFUNCTION);

    return result;
  };
  getDevicesByType = (
    deviceType = DeviceTypes.ALL,
    areaDevices = undefined
  ) => {
    return this.props.deviceReducer.list.filter((d) => {
      return (
        // no filter
        (deviceType == DeviceTypes.ALL ||
          // or battery devices
          (deviceType == DeviceTypes.BATTERY && d.batteryLevel >= 0) ||
          // or malfunctioning devices
          (deviceType == DeviceTypes.MALFUNCTION &&
            (d.isFailed || d.isExcluded)) ||
          // or filtered type
          d.deviceType == deviceType) &&
        (!areaDevices ||
          //(d.deviceUId && areaDevices.indexOf(d.deviceUId) >= 0) ||
          areaDevices.indexOf(d.deviceId || d.deviceUId) >= 0)
      );
    });
  };
  initList = (initDeviceType = "") => {
    // if (this.props.deviceReducer.list.length > 0) {}
    var _areaDevices = undefined;
    var _areaUDevices = undefined;
    var _filterAreaDevices = undefined;
    var _areaName = undefined;
    if (this.state.areaId || this.state.areaUId) {
      for (var i in this.props.areaReducer.areas) {
        const area = this.props.areaReducer.areas[i];
        if (
          // (this.state.this.state.areaIdUId &&
          //   this.props.areaReducer.areas[i].areaUId == this.state.areaUId) ||
          area?.areaId == this.state.areaId ||
          area.areaUId == this.state.areaUId
        ) {
          this.model = area;
          _areaDevices = this.model.devices || [];
          _areaUDevices = this.model.uDevices || [];
          if (_areaDevices.length > 0 || _areaUDevices.length > 0)
            _filterAreaDevices = [..._areaDevices, ..._areaUDevices];
          _areaName = this.model.areaName;
          break;
        }
      }
    }

    var deviceTypes = this.getDeviceTypes(_filterAreaDevices);

    var _selectedType = DeviceTypes.ALL;
    if (initDeviceType) {
      _selectedType = initDeviceType;
    } else if (deviceTypes.length >= 2) {
      if (
        deviceTypes.length >= 3 && // if has filters more than ALL and BATTERY
        deviceTypes[1] == DeviceTypes.BATTERY && // and second filter is BATTERy
        this.state.deviceTypeFilter != DeviceTypes.BATTERY // but default filter is not BATTERY
      ) {
        _selectedType = deviceTypes[2]; // select third item (first item appeared after "ALL" and "BATTERY")
      } else {
        _selectedType = deviceTypes[1]; // select second item (first item appeared after "ALL")
      }
    }

    var deviceList = this.getDevicesByType(_selectedType, _filterAreaDevices);
    this.sortDevices(deviceList);
    this.setState({
      areaName: _areaName,
      areaDevices: _areaDevices,
      areaUDevices: _areaUDevices,
      deviceList: deviceList,
      deviceTypeFilter: _selectedType,
      deviceTypes,
      isLoading: false,
    });
  };

  reloadDeviceTypes = () => {
    return new Promise((resolve) => {
      var deviceTypes = [DeviceTypes.ALL];
      var devices = [];
      if (this.state.areaId || this.state.areaUId) {
        var area = this.props.areaReducer.areas.find(
          (a) =>
            a?.areaId == this.state.areaId || a.areaUId == this.state.areaUId
        );
        if (area) {
          var _devices = area.devices || [];
          var _uDevices = area.uDevices || [];
          devices = [..._devices, ..._uDevices];
        }
      } else {
        devices = this.props.deviceReducer.list;
      }

      for (var i in devices) {
        var typ = devices[i].deviceType;
        if (deviceTypes.indexOf(typ) < 0) deviceTypes.push(typ);
      }
      this.setState({ deviceTypes }, () => {
        resolve && resolve();
      });
    });
  };

  onEditCompleted = (newDeviceType) => {
    this.reloadDeviceTypes().then(() => {
      this.setState({ isLoading: true }, () => {
        setTimeout(() => {
          this.initList(newDeviceType);
        }, 500);
      });
    });
  };

  componentDidMount() {
    // set dummy timeout just to put process in background thread
    setTimeout(() => {
      this.initList();
    }, 1);

    this.setState({
      accessToken: this.props.appReducer?.currentServer.accessToken,
      isLoading: false,
    });
  }
  componentDidUpdate() {
    var newNode = Number(this.props.deviceReducer.includedNodeId) || 0;
    if (newNode && this.props.deviceReducer.includeTimeout) {
      this.props.addNewNodeToAreaLocally(
        newNode,
        this.state.areaId,
        this.state.areaUId
      );
      this.props.resetIncludeTimeout();
    }
    if (this.state.areaId && this.model && this.model.devices) {
      for (var i in this.props.areaReducer.areas) {
        if (this.props.areaReducer.areas[i].areaId == this.state.areaId) {
          if (
            this.model.devices.length !=
            this.props.areaReducer.areas[i].devices?.length
          ) {
            this.model.devices = this.props.areaReducer.areas[i].devices;
          }
          break;
        }
      }
    } else if (this.state.areaUId && this.model && this.model.uDevices) {
      for (var i in this.props.areaReducer.areas) {
        if (this.props.areaReducer.areas[i].areaUId == this.state.areaUId) {
          if (
            this.model.uDevices.length !=
            this.props.areaReducer.areas[i].uDevices?.length
          ) {
            this.model.uDevices = this.props.areaReducer.areas[i].uDevices;
          }
          break;
        }
      }
    }
  }

  componentWillUnmount() {
    // remove assigned events on backButtonEventListener
    this.handleBackButtonPress();
  }

  handleBackButtonPress = () => {
    this.setState({
      showCheckbox: false,
      checkedItems: [],
      checkedItemsUId: [],
    }); // hide checkboxes and clear selected list.

    BackHandler.removeEventListener(
      "hardwareBackPress",
      this.handleBackButtonPress
    );
    return true;
  };

  // press on every deviceListItems
  handleOnItemPress = (deviceId, deviceUId) => {
    if (!this.state.showCheckbox) {
      BackHandler.addEventListener(
        "hardwareBackPress",
        this.handleBackButtonPress
      );
    }
    let newCheckedList = [...this.state.checkedItems];
    let newCheckedListUId = [...this.state.checkedItemsUId];
    if (
      newCheckedList.indexOf(deviceId) >= 0 ||
      newCheckedListUId.indexOf(deviceUId) >= 0
    ) {
      newCheckedList.splice(newCheckedList.indexOf(deviceId), 1);
      newCheckedListUId.splice(newCheckedListUId.indexOf(deviceUId), 1);
    } else {
      newCheckedList.push(deviceId);
      newCheckedListUId.push(deviceUId);
    }
    this.setState({
      showCheckbox: true,
      checkedItems: newCheckedList,
      checkedItemsUId: newCheckedListUId,
    });
  };

  onAddButtonPress = () => {
    this.props.navigation.navigate("DeviceAdd", {
      areaId: this.state.areaId,
      areaUId: this.state.areaUId,
      onGoBack: (newDeviceType) => {
        this.onEditCompleted(newDeviceType);
      },
    });
  };

  onRefreshButtonPress = () => {
    this.setState({ isLoading: true });
    this.props.clearAll();
    this.props.getAll(
      this.state.areaId,
      this.state.areaUId,
      this.state.accessToken
    );
    setTimeout(() => {
      let { deviceTypeFilter } = this.state;
      if (
        this.props.deviceReducer.list.some(
          (d) => d.deviceType == deviceTypeFilter
        )
      )
        this.initList(deviceTypeFilter);
      else this.initList();
      //this.setState({ isLoading: false });
    }, 5000);
  };

  checkCanEdit = (deviceIds) => {
    // multiple deviceIds
    if (Array.isArray(deviceIds) && deviceIds.length > 1) {
      return this.props.deviceReducer.list
        .filter((d) =>
          typeof deviceIds[0] == "number"
            ? deviceIds.indexOf(d.deviceId) >= 0
            : deviceIds.indexOf(d.deviceUId) >= 0
        )
        .every((d) => d.canEdit);
    }
    // single deviceId
    if (Array.isArray(deviceIds) && deviceIds.length == 1) {
      if (typeof deviceIds[0] == "number") {
        return this.props.deviceReducer.list.some(
          (d) => d.deviceId === Number(deviceIds) && d.canEdit
        );
      } else {
        return this.props.deviceReducer.list.some(
          (d) => d.deviceUId === deviceIds[0] && d.canEdit
        );
      }
    }
  };

  checkCanAddDevice = () => {
    return this.props.areaReducer.areas.some((a) => a.accessLevelValue >= 1000); // 1000 is admin, 5000 is support
  };

  renderEditMenu = () => {
    return (
      <View style={style.editMenu}>
        {/* cancel */}
        <EditMenuIcon
          icon={faTimes}
          text={translate("app.cancel")}
          color={Theme.COLORS.MUTED}
          onPress={() => this.onMenuCancel()}
        />
        {/* edit */}
        {(this.state.checkedItems.length == 1 ||
          this.state.checkedItemsUId.length == 1) &&
          this.checkCanEdit(
            this.state.checkedItems || this.state.checkedItemsUId
          ) && (
            <EditMenuIcon
              icon={faEdit}
              text={`${translate("app.details")}/${translate("app.edit")}`}
              onPress={() => this.onMenuEdit()}
            />
          )}
        {/* copy */}
        {this.state.checkedItems.length > 0 &&
          this.checkCanEdit(
            this.state.checkedItems || this.state.checkedItemsUId
          ) && (
            <EditMenuIcon
              icon={faCopy}
              text={translate("app.copy")}
              onPress={() => this.onMenuCopy()}
            />
          )}
        {/* move */}
        {this.state.checkedItems.length > 0 &&
          this.model.areaId &&
          this.checkCanEdit(
            this.state.checkedItems || this.state.checkedItemsUId
          ) && (
            <EditMenuIcon
              icon={faExchangeAlt}
              text={translate("app.move")}
              onPress={() => this.onMenuMove()}
            />
          )}
        {/* remove */}
        {this.state.checkedItems.length == 1 &&
          //this.model.areaId &&
          this.checkCanEdit(
            this.state.checkedItems || this.state.checkedItemsUId
          ) && (
            <EditMenuIcon
              icon={faEraser}
              text={translate("app.remove")}
              onPress={() => {
                this.setState({ isShowingDeleteAlert: true });
              }}
              // onPress={() => this.onMenuUnlink()}
            />
          )}
        {/* AwesomeAlert choose remove */}
        {this.state.isShowingDeleteAlert && (
          <AlertDialogBase
            isOpen={true}
            title={translate("device.removeDevice?")}
            confirmText={translate("device.removeFromArea")}
            colorConfirm="error"
            confirmHandler={() => {
              this.setState({
                isShowingDeleteAlert: false,
              });

              this.props.unlinkFromArea(
                this.model.areaId,
                this.model.areaUId,
                this.state.checkedItems,
                this.state.checkedItemsUId,
                this.state.accessToken
              );
              this.onEditCompleted(this.state.deviceTypeFilter);
            }}
            onClose={() => {
              this.setState({
                isShowingDeleteAlert: false,
              });

              console.log("todo: navigate to delete form");
            }}
          />
        )}

        {/* toggle select all */}
        <EditMenuIcon
          icon={faCheckSquare}
          text={translate("app.selectAll")}
          onPress={() => this.onMenuSelectAll()}
        />
      </View>
    );
  };

  onMenuCancel = () => {
    // will clear checked items and hide menu.(show add button)
    this.handleBackButtonPress();
  };
  onMenuEdit = () => {
    let deviceId = this.state.checkedItems[0];
    let deviceType = "";
    let device = undefined;

    for (var i in this.props.deviceReducer.list) {
      var d = this.props.deviceReducer.list[i];
      if ((d.deviceUId && deviceId == d.deviceUId) || d.deviceId == deviceId) {
        deviceType = d.deviceType;
        device = d;
        break;
      }
    }

    if (!device) return;

    if (device.isLite == true) {
      this.props.getDetails(
        deviceId,
        device.deviceUId,
        deviceType,
        this.state.accessToken
      );
    }
    this.setState({ detailsModalVisible: true });
    return;
  };
  onMenuCopy = () => {
    // route to SelectTargetArea and pass checked devices id lists.
    // user will select one or more area to copying devices. proper action will dispatch in target view.
    BackHandler.removeEventListener(
      "hardwareBackPress",
      this.handleBackButtonPress
    );

    this.props.navigation.navigate("DeviceToArea", {
      devices: this.state.checkedItems,
      devicesUId: this.state.checkedItemsUId,
      oldAreaId: this.model.areaId,
      oldAreaUId: this.model.areaUId,
      transport: "copy",
      restricted: true, // determines that restricted to search among related areas to old area or can search through all areas based on user access.
    });
  };
  onMenuMove = () => {
    // route to SelectTargetArea and pass checked devices id lists and current areaId as old areaId
    // in order to remove devices from this area after moving finished.
    // user will select one or more area for moving devices. proper action will dispatch in target view.
    BackHandler.removeEventListener(
      "hardwareBackPress",
      this.handleBackButtonPress
    );
    this.props.navigation.navigate("DeviceToArea", {
      devices: this.state.checkedItems,
      devicesUId: this.state.checkedItemsUId,
      oldAreaId: this.model.areaId,
      oldAreaUId: this.model.areaUId,
      transport: "move",
      restricted: true, // determines that restricted to search among related areas to old area or can search through all areas based on user access.
      onGoBack: (newDeviceType) => {
        this.onEditCompleted(newDeviceType);
      },
    });
  };
  // onMenuUnlink = () => {
  //   // notice user with alert that selected devices will soft remove from current list (not hard physical remove)
  //   Alert.alert(
  //     translate("device.removeDevice?"),
  //     translate("device.unlinkDeviceInfo"),
  //     [
  //       {
  //         text: translate("app.remove"),
  //         onPress: () =>
  //           this.props.unlinkFromArea(
  //             this.model.areaId,
  //             this.state.checkedItems,
  //             this.state.accessToken
  //           ),
  //       },
  //       { text: translate("app.cancel") },
  //     ]
  //   );
  // };
  onMenuSelectAll = () => {
    let { deviceTypeFilter, deviceNameFilter } = this.state;
    // check all if some checked or none checked.deselect if all is checked.
    var showedDevices = this.getFilteredList(
      deviceTypeFilter,
      deviceNameFilter
    ).map((d, i) => d.deviceId);
    // === devices UId ===
    var showedDevicesUId = this.getFilteredList(
      deviceTypeFilter,
      deviceNameFilter
    ).map((d, i) => d.deviceUId);

    var allCount = showedDevices.length;
    if (this.state.checkedItems.length < allCount) {
      // select all
      let _checkedItems = [...showedDevices];
      let _checkedItemsUId = [...showedDevicesUId];
      this.setState({
        checkedItems: _checkedItems,
        checkedItemsUId: _checkedItemsUId,
      });
    } else {
      //deselect all
      this.setState({ checkedItems: [], checkedItemsUId: [] });
    }
  };
  dismissNewNodeModal = () => {
    this.props.resetNewIncludedNodeLocally();
  };
  dismissDetailLoaderModal = () => {
    return new Promise((resolve) => {
      this.setState(
        {
          detailsModalVisible: false,
        },
        () => {
          resolve();
        }
      );
    });
  };
  changeDeviceTypeFilter = (deviceTypeFilter = DeviceTypes.ALL) => {
    if (this.state.deviceTypeFilter != deviceTypeFilter) {
      this.setState({ isLoading: true }, () => {
        // set dummy timeout just to put process in background thread
        setTimeout(() => {
          var deviceList = this.getDevicesByType(
            deviceTypeFilter,
            this.state.areaDevices
          );

          var deviceSortFilter = this.state.deviceSortFilter;

          if (deviceTypeFilter == DeviceTypes.BATTERY) {
            deviceSortFilter = this._sortBy_Types.batteryLevel;
          } else if (deviceSortFilter == this._sortBy_Types.batteryLevel) {
            deviceSortFilter = this._sortBy_Types.alphabetic;
          }

          this.setState({
            deviceTypeFilter,
            deviceSortFilter,
            checkedItems: [],
            deviceList,
            isLoading: false,
          });
        }, 1);
      });
    }
  };

  getFilteredList = (
    deviceTypeFilter = DeviceTypes.ALL,
    deviceNameFilter = ""
  ) => {
    var deviceList = [];
    deviceNameFilter = deviceNameFilter.toLowerCase().trim();
    // no filter, no process, just return reducer list
    if (deviceTypeFilter == DeviceTypes.ALL && deviceNameFilter == "") {
      //deviceList = this.props.deviceReducer.list;
      deviceList = this.state.deviceList;
    }
    // no nameFilter, only check device type filter
    else if (deviceNameFilter == "") {
      // deviceList = this.props.deviceReducer.list.filter((d) => {
      //   if (deviceTypeFilter == d.deviceType) return d;
      // });
      deviceList = this.state.deviceList;
    }
    // check both filters
    else {
      deviceList = this.state.deviceList.filter(
        (d) => d.deviceName.toLowerCase().indexOf(deviceNameFilter) >= 0
      );
    }

    this.sortDevices(deviceList);

    return deviceList;
  };

  renderDetailsLoader = () => {
    let deviceId = this.state.checkedItems[0] || 0;
    let deviceUId = this.state.checkedItemsUId[0] || null;
    let deviceType = "";
    let device = undefined;
    let isGPIODevice = false;
    let isLite = undefined;
    let areaNames = undefined;

    if ((deviceId > 0 || deviceUId) && this.state.detailsModalVisible) {
      for (var i in this.props.deviceReducer.list) {
        var d = this.props.deviceReducer.list[i];
        if (
          d?.deviceId == deviceId ||
          (deviceUId && d.deviceUId == deviceUId)
        ) {
          deviceType = d.deviceType;
          isLite = d.isLite;
          deviceId = d?.deviceId;
          deviceUId = d?.deviceUId;
          device = d;
          areaNames = this.props.areaReducer.areas
            .filter(
              (a) =>
                a.devices &&
                (a.devices.includes(deviceId) || a.uDevices.includes(deviceUId))
            )
            .map((a) => a.areaName);
          if (d.gpioPortNumber > 0 || d.unlockerGPIOPortNumber > 0) {
            isGPIODevice = true;
          }
          break;
        }
      }
      //console.log("deviceId, deviceType, isLite", deviceId, deviceType, isLite);
    }

    // if is true or undefined
    if (!device || isLite != false) {
      return (
        <View style={style.detailLoaderModal}>
          {/* <Loading /> */}
          <Spinner size={50} />
        </View>
      );
    } else {
      return (
        <View style={style.detailLoaderModal}>
          {/* content */}
          <View>
            {/* device name */}
            <Text
              style={{ fontWeight: "bold", marginTop: 10, textAlign: "center" }}
            >
              {device.deviceName}
            </Text>
            {/* errors */}
            {device.isExcluded == true && (
              <Text
                style={{
                  fontWeight: "bold",
                  marginTop: 5,
                  textAlign: "center",
                  color: Theme.COLORS.ERROR,
                }}
              >
                {translate("device.isExcluded")}
              </Text>
            )}
            {device.isFailed == true && (
              <Text
                style={{
                  fontWeight: "bold",
                  marginTop: 5,
                  textAlign: "center",
                  color: Theme.COLORS.ERROR,
                }}
              >
                {translate("device.isFailed")}
              </Text>
            )}
            {/* gpio description */}
            {isGPIODevice && (
              <Text style={{ textAlign: "center" }}>
                GPIO: {device.gpioPortNumber}
              </Text>
            )}
            {/* camera ip */}
            {deviceType == DeviceTypes.CAMERA && (
              <Text style={{ textAlign: "center" }}>
                {device.protocol}
                {"://"}
                {device.ip}
                {device.port ? `:${device.port}` : ""}
              </Text>
            )}
            {/* areas */}
            {Array.isArray(areaNames) && areaNames.length > 0 && (
              <View>
                <Text style={{ textAlign: "center", marginTop: 20 }}>
                  {translate("navigation.AreasList")}
                  {":"}
                </Text>
                {areaNames.map((aName, i) => {
                  return (
                    <Text
                      key={i}
                      style={{ textAlign: "center", marginTop: 10 }}
                    >
                      {aName}
                    </Text>
                  );
                })}
              </View>
            )}
          </View>
          {/* navigate button */}
          <HStack space={2} style={{ padding: 10, width: "100%" }}>
            <ArButton
              color="primary"
              onPress={() => {
                this.dismissDetailLoaderModal().then(() => {
                  if (deviceType == DeviceTypes.CAMERA) {
                    this.props.navigation.navigate("CameraForm", {
                      deviceId,
                      deviceUId,
                      onGoBack: (newDeviceType) => {
                        this.onEditCompleted(newDeviceType);
                      },
                    });
                    return;
                  }

                  if (deviceType == DeviceTypes.SMART_SPEAKER) {
                    this.props.navigation.navigate("SmartSpeakerForm", {
                      deviceId,
                      deviceUId,
                      onGoBack: (newDeviceType) => {
                        this.onEditCompleted(newDeviceType);
                      },
                    });
                    return;
                  }

                  if (deviceType == DeviceTypes.ELEVATOR) {
                    this.props.navigation.navigate("ElevatorForm", {
                      deviceId,
                      deviceUId,
                      onGoBack: (newDeviceType) => {
                        this.onEditCompleted(newDeviceType);
                      },
                    });
                    return;
                  }

                  if (isGPIODevice) {
                    this.props.navigation.navigate("GPIOForm", {
                      deviceId,
                      deviceUId,
                      onGoBack: (newDeviceType) => {
                        this.onEditCompleted(newDeviceType);
                      },
                    });
                    return;
                  }
                  if (deviceType == DeviceTypes.TOUCH_PANEL) {
                    this.props.navigation.navigate("TouchPanelForm", {
                      deviceId,
                      deviceUId,
                      onGoBack: (newDeviceType) => {
                        this.onEditCompleted(newDeviceType);
                      },
                    });
                    return;
                  }

                  if (deviceType == DeviceTypes.ACCESS_CONTROL) {
                    this.props.navigation.navigate("AccessControlForm", {
                      deviceId,
                      deviceUId,
                      onGoBack: (newDeviceType) => {
                        this.onEditCompleted(newDeviceType);
                      },
                    });
                    return;
                  }

                  // simply route to DeviceFormScreen
                  this.props.navigation.navigate("DeviceForm", {
                    deviceId,
                    deviceUId,
                    areaId: this.state.areaId,
                    areaUId: this.state.areaUId,
                    areaName: this.state.areaName,
                    onGoBack: (newDeviceType) => {
                      this.onEditCompleted(newDeviceType);
                    },
                  });
                });
              }}
              style={{ flex: 1, marginBottom: 0 }}
            >
              {translate("app.edit")}
            </ArButton>
            <ArButton
              color="muted"
              variant="outline"
              onPress={this.dismissDetailLoaderModal}
              style={{ flex: 1, marginBottom: 0 }}
            >
              {translate("app.close")}
            </ArButton>
          </HStack>
        </View>
      );
    }
  };

  sortDevices = (deviceList) => {
    // console.log('this.state.deviceSortFilter', this.state.deviceSortFilter);
    switch (this.state.deviceSortFilter) {
      case this._sortBy_Types.alphabetic:
        deviceList.sort((a, b) => {
          if (a.deviceName > b.deviceName) return 1;
          else if (a.deviceName < b.deviceName) return -1;
          // if equal, use deviceType to compare
          else {
            if (a.deviceType > b.deviceType) return 1;
            else if (a.deviceType < b.deviceType) return -1;
            // if equal, use deviceId to compare
            else a.deviceId >= b.deviceId ? 1 : -1;
          }
        });
        break;
      case this._sortBy_Types.deviceCode:
        deviceList.sort((a, b) => {
          {
            if (a.deviceCode > b.deviceCode) return 1;
            else if (a.deviceName < b.deviceName) return -1;
            // if equal
            else return a.deviceType > b.deviceType ? 1 : -1;
          }
        });
        break;
      case this._sortBy_Types.batteryLevel:
        deviceList.sort((a, b) => {
          {
            if (a.batteryLevel > b.batteryLevel) return 1;
            else if (a.batteryLevel < b.batteryLevel) return -1;
            else if (a.deviceCode > b.deviceCode) return -1;
            // else if (a.deviceType > b.deviceType) return -1;
            // if equal
            else return a.deviceName < b.deviceName ? 1 : -1;
          }
        });
        break;
    }
  };
  toggleCollapseFilter = () => {
    this.setState({ toggleFilterCollapse: !this.state.toggleFilterCollapse });
  };
  onUpdateControllerHandler = (action, deviceId, deviceUId, newVersion) => {
    this.props.UpdateController(action, deviceId, deviceUId, newVersion);
  };

  render() {
    // if (this.props.areaReducer.isLoading || this.state.isLoading) {
    //   return <Loading message={translate("app.pleaseWaite")} />;
    // } else

    if (Number(this.props.deviceReducer.includeTimeout)) {
      var initUntil = Number(this.props.deviceReducer.includeTimeout);

      return (
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <Countdown
            until={initUntil}
            digitStyle={{
              backgroundColor: this.state.timerColor,
              borderRadius: 70,
              width: 140,
              height: 140,
              marginBottom: 10,
            }}
            digitTxtStyle={{
              color: "#FFF",
            }}
            size={70}
            timeToShow={["S"]}
            timeLabels={{ s: "" }}
            onChange={(t) => {
              if (t > 7) {
                if (this.state.timerColor != Theme.COLORS.PRIMARY) {
                  this.setState({ timerColor: Theme.COLORS.PRIMARY });
                }
              } else if (t > 4) {
                if (this.state.timerColor != Theme.COLORS.BUTTON_COLOR) {
                  this.setState({ timerColor: Theme.COLORS.BUTTON_COLOR });
                }
              } else if (t > 0) {
                if (this.state.timerColor != Theme.COLORS.ERROR) {
                  this.setState({ timerColor: Theme.COLORS.ERROR });
                }
              } else {
                this.setState({ timerColor: Theme.COLORS.PRIMARY });
              }
            }}
            onFinish={() => {
              // set timeout to prevent warning for unmounted component
              setTimeout(() => {
                this.setState({ timerColor: Theme.COLORS.PRIMARY }, () =>
                  this.props.resetIncludeTimeout()
                );
              }, 100);
            }}
          />
          <Text style={{ color: Theme.COLORS.MUTED }}>
            {translate("device.pressIncludeButton")}
          </Text>
        </View>
      );
    } else if (Number(this.props.deviceReducer.includedNodeId) > 0) {
    }

    // else
    var deviceList = this.getFilteredList(
      this.state.deviceTypeFilter,
      this.state.deviceNameFilter
    );

    var hasDevice = deviceList.length > 0;
    var _sortFilterItems = this._sortBy_Types.getArray(
      this.state.deviceTypeFilter == DeviceTypes.BATTERY
    );

    return (
      <KeyboardAvoidingView behavior="height" style={{ flex: 1 }}>
        <View style={{ flex: 1 }}>
          <View
            style={{
              height: 36,
              marginTop: 3,
              backgroundColor: Theme.COLORS.BORDER_COLOR,
              // flexDirection: "row",
              // marginBottom:5
            }}
          >
            <FilterItem
              listItem={this.state.deviceTypes.map((dt) => {
                return { text: translate(`deviceGroup.${dt}`), value: dt };
              })}
              selectedItem={this.state.deviceTypeFilter}
              onSelect={(item) => this.changeDeviceTypeFilter(item)}
            />
          </View>
          {/* device type filter (badge list) */}
          {/* device name and sort filter */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: 20,
              paddingHorizontal: 5,
            }}
          >
            <View
              style={{
                flex: 1,
              }}
            >
              <InputSearch
                containerStyle={{ marginBottom: 3 }}
                label={translate("device.deviceName")}
                placeholder={translate("app.search")}
                value={this.state.deviceNameFilter}
                onChangeText={(txt) => {
                  this.setState({ deviceNameFilter: txt, checkedItems: [] }); // set filter text and clear checked items.
                }}
              />
            </View>
            <View
              style={{ flex: 1, marginStart: 5, marginEnd: 10, width: "50%" }}
            >
              <Select
                label={translate("device.sort")}
                data={_sortFilterItems.map((v) => {
                  return { value: v, label: translate(`device.${v}`) };
                })}
                value={this.state.deviceSortFilter}
                onChangeText={(value, index, data) => {
                  this.setState({
                    deviceSortFilter: _sortFilterItems.find((i) => i == value),
                  });
                }}
              />
            </View>
          </View>
          {/* end device name and sort filter */}
          {this.state.checkedItems.length > 0 && (
            <View
              style={{ marginHorizontal: 20, marginVertical: 10, height: 20 }}
            >
              <Text style={{ fontSize: 11, color: Theme.COLORS.MUTED }}>
                {this.state.checkedItems.length}{" "}
                {translate("app.itemsSelected")}
              </Text>
            </View>
          )}
          {this.props.areaReducer.isLoading || this.state.isLoading ? (
            <Loading message={translate("app.pleaseWaite")} />
          ) : (
            <ScrollView
              style={{
                flex: 1,
                // marginBottom: 85,
                // borderTopWidth: 1,
                paddingBottom: 10,
                paddingHorizontal: 5,
                // borderColor: Theme.COLORS.INPUT,
              }}
              showsVerticalScrollIndicator={false}
            >
              {deviceList.length == 0 ? (
                <View style={{ paddingHorizontal: 10 }}>
                  <MessageBox icon={faLightbulb}>
                    {translate("app.emptyList")}
                  </MessageBox>
                </View>
              ) : (
                deviceList.map((d, idx) => {
                  var _updateDeviceAvailable = updateDeviceAvailable(d);
                  return (
                    <DeviceListItem
                      styleContainer={
                        idx === deviceList.length - 1 &&
                        this.state.showCheckbox && { marginBottom: 65 }
                      }
                      showCheckbox={this.state.showCheckbox}
                      showOnHomeScreen={d.showOnHomeScreen}
                      isActive={!d.isFailed && !d.isExcluded}
                      isChecked={
                        this.state.checkedItems.indexOf(
                          d.deviceId || d.deviceUId
                        ) >= 0
                      }
                      isGpio={d.gpioPortNumber > 0}
                      onPress={() => {
                        this.handleOnItemPress(d.deviceId, d.deviceUId);
                      }}
                      onPressUpdateController={(action) => {
                        // === action => "download" , "install" ===
                        if (action) {
                          this.onUpdateControllerHandler(
                            action,
                            d.deviceId,
                            d.deviceUId,
                            d.nextVersion
                          );
                        } else {
                          this.props.navigation.navigate(
                            "DeviceFormController",
                            {
                              deviceId: d.deviceId,
                              deviceUId: d.deviceUId,
                              deviceType: d.deviceType,
                              deviceName: d.deviceName,
                              onGoBack: (newDeviceType) => {
                                this.reloadDeviceTypes().then(
                                  this.initList(newDeviceType)
                                );
                              },
                            }
                          );
                        }
                      }}
                      onLongPress={
                        () => this.handleOnItemPress(d.deviceId, d.deviceUId)
                        // this.removeDeviceWithConfirm(d.deviceId, d.deviceName)
                      }
                      onTogglePress={(deviceId, newValue) => {
                        this.props.updateSwitchBinary(
                          d.deviceId,
                          d.deviceUId,
                          newValue,
                          this.state.accessToken
                        );
                      }}
                      onUnlockPress={(deviceId) => {
                        this.props.unlock(
                          d.deviceId,
                          d.deviceUId,
                          this.state.accessToken
                        );
                      }}
                      style={{ backgroundColor: "blue" }}
                      key={idx}
                      deviceId={d.deviceId}
                      deviceUId={d.deviceUId}
                      deviceType={d.deviceType}
                      deviceName={d.name || d.deviceName}
                      statusRelayId={d.statusRelayId}
                      deviceCode={d.deviceCode}
                      genericType={d.genericType}
                      deviceValue={
                        d.isTurnedOn || d.isOpen || d.value || d.detected
                      }
                      batteryLevel={d.batteryLevel}
                      updateDeviceAvailable={_updateDeviceAvailable}
                      goToDeviceLog={() => {
                        this.props.navigation.navigate("DeviceLogs", {
                          deviceId: d.deviceId,
                          deviceUId: d.deviceUId,
                          deviceType: d.deviceType,
                        });
                      }}
                    />
                  );
                })
              )}
            </ScrollView>
          )}
          {this.state.showCheckbox && this.renderEditMenu()}

          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {!this.state.showCheckbox && this.checkCanAddDevice() && (
              <TouchableHighlight
                underlayColor="transparent"
                style={style.btnAdd}
                onPress={this.onAddButtonPress}
              >
                <FontAwesomeIcon icon={faPlus} size={25} color="#FFF" />
              </TouchableHighlight>
            )}

            {!this.state.showCheckbox &&
              (this.state.areaId == undefined ||
                this.state.areaUId == undefined) && (
                <TouchableHighlight
                  style={style.btnRefresh}
                  onPress={this.onRefreshButtonPress}
                >
                  <FontAwesomeIcon icon={faSyncAlt} size={15} color="#FFF" />
                </TouchableHighlight>
              )}
          </View>
          <ModalBase
            isOpen={this.props.deviceReducer.includedNodeId > 0}
            onClose={() => this.dismissNewNodeModal()}
            // contentStyle={{ height: "100%" }}
          >
            <View style={style.modalInsideWrapper}>
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 14,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                {translate("device.newDeviceAdded")}
              </Text>
              <HStack space="2">
                <ArButton
                  color="primary"
                  onPress={() => {
                    this.dismissNewNodeModal();
                    this.props.navigation.navigate("DeviceForm", {
                      deviceId: this.props.deviceReducer.includedNodeId,
                      deviceUId: this.props.deviceReducer.includedNodeUId,
                      onGoBack: (newDeviceType) => {
                        this.reloadDeviceTypes().then(
                          this.initList(newDeviceType)
                        );
                      },
                    });
                  }}
                  style={{ flex: 1, marginBottom: 0 }}
                >
                  {translate("app.edit")}
                </ArButton>
                <ArButton
                  color="muted"
                  onPress={() => this.dismissNewNodeModal()}
                  style={{ flex: 1, marginBottom: 0 }}
                >
                  {translate("app.skip")}
                </ArButton>
              </HStack>
            </View>
          </ModalBase>
          <ModalBase
            isOpen={this.state.detailsModalVisible}
            onClose={() => this.dismissDetailLoaderModal()}
            // contentStyle={{ height: "100%" }}
          >
            {this.renderDetailsLoader()}
          </ModalBase>
        </View>
      </KeyboardAvoidingView>
    );
  }
}

const style = StyleSheet.create({
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: Theme.COLORS.PRIMARY,
    //position: "absolute",
    marginHorizontal: 15,
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  btnRefresh: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: Theme.COLORS.TL_PURPLE,
    //position: "absolute",
    bottom: 5,
    // marginEnd: -30,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  btnMiniAdd: {
    width: 50,
    height: 50,
    borderRadius: 25,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 15,
    alignSelf: "center",
    marginBottom: 5,
  },
  btnMiniAddTitle: {
    backgroundColor: "#000000",
    color: "#fff",
    borderRadius: 10,
    textAlign: "center",
    marginBottom: 10,
    fontSize: 16,
  },
  btnMiniAddHoler: {
    position: "absolute",
    bottom: 90,
    alignSelf: "center",
  },
  editMenu: {
    position: "absolute",
    height: 42,
    width: "90%",
    bottom: 15,
    // shadowOffset : {width : 0 , height : -5},
    shadowColor: "#0000008a",
    shadowRadius: 8,
    elevation: 3,
    alignSelf: "center",
    borderWidth: 0,
    borderColor: Theme.COLORS.MUTED,
    borderRadius: 10,
    backgroundColor: "#FFF",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    // paddingHorizontal: 10
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
    marginBottom: 16,
  },
  hint: {
    textAlign: "center",
    color: Theme.COLORS.MUTED,
  },
  modalInsideWrapper: {
    justifyContent: "center",
    borderRadius: 10,
    padding: 10,
    height: 110,
  },
  areaIncludeSection: {
    backgroundColor: "#dddddd50",
    paddingVertical: 15,
    marginTop: 15,
    alignItems: "center",
  },
  areaIncludeDongle: {
    //  backgroundColor: "#FFF",
    //padding: 15,
    marginHorizontal: 15,
    marginVertical: 10,
    // width : '90%'
    // borderRadius: 10,
  },
  iosRtl: {
    textAlign: Platform.OS == "ios" ? "left" : "auto",
  },
  detailLoaderModal: {
    height: 250,
    width: "100%",
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 5,
  },
});

const mapStateToProps = (state) => {
  return {
    areaReducer: state.AreaReducer,
    deviceReducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAll: (areaId, areaUId, accessToken) =>
      dispatch(Actions.GetAll(areaId, areaUId, null, accessToken)),
    getDetails: (deviceId, deviceUId, deviceType, accessToken) =>
      dispatch(
        Actions.GetDetails(deviceId, deviceUId, deviceType, accessToken)
      ),
    remove: (deviceId) => dispatch(Actions.Remove(deviceId)),
    unlinkFromArea: (areaId, areaUId, devices, devicesUId, accessToken) =>
      dispatch(
        AreaActions.unlinkDevices(
          areaId,
          areaUId,
          devices,
          devicesUId,
          accessToken
        )
      ),
    tryInclude: (areaId, areaUId, accessToken) =>
      dispatch(Actions.TryInclude(areaId, areaUId, accessToken)),
    tryIncludeToHomeId: (areaId, areaUId, homeId, accessToken) =>
      dispatch(
        Actions.tryIncludeToHomeId(areaId, areaUId, homeId, accessToken)
      ),
    CountDownIncludeTimeout: () => dispatch(Actions.CountDownIncludeTimeout()),
    resetIncludeTimeout: () => dispatch(Actions.ResetIncludeTimeout()),
    addNewNodeToAreaLocally: (deviceId, areaId, areaUId) =>
      dispatch(AreaActions.addNewNodeToAreaLocally(deviceId, areaId, areaUId)),
    resetNewIncludedNodeLocally: () =>
      dispatch(Actions.resetNewIncludedNodeLocally()),
    updateSwitchBinary: (deviceId, deviceUId, value, accessToken) => {
      if (value) {
        dispatch(SwitchBinaryActions.turnOn(deviceId, deviceUId, accessToken));
      } else {
        dispatch(SwitchBinaryActions.turnOff(deviceId, deviceUId, accessToken));
      }
    },
    unlock: (deviceId, deviceUId, accessToken) =>
      dispatch(DoorLockActions.Unlock(deviceId, deviceUId, accessToken)),

    // === Update Controller ===
    UpdateController: (action, deviceId, deviceUId, nextVersion) =>
      dispatch(
        Actions.UpdateController(action, deviceId, deviceUId, nextVersion)
      ),
    clearAll: () => dispatch(Actions.ClearAll()),
  };
};

class EditMenuIcon extends Component {
  render() {
    var clr = this.props.color || Theme.COLORS.PRIMARY;
    return (
      <TouchableHighlight
        underlayColor="#f2f2f2"
        onPress={() => this.props.onPress && this.props.onPress()}
        style={{ borderRadius: 5 }}
      >
        <View style={{ alignItems: "center" }}>
          <FontAwesomeIcon icon={this.props.icon || faEdit} color={clr} />
          <Text style={{ color: clr, fontSize: 12 }}>
            {this.props.text || ""}
          </Text>
        </View>
      </TouchableHighlight>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(DeviceListScreen);
